/**
 * Styled Components - Created by cazarez on 13/03/18.
 */
interface TitleProps {
  titleWidth?: string
  titleColor?: string
  fontSize?: string
  display?: string
  alignItems?: string
}

interface ContainerProps {
  width?: string
}

interface DivProps {
  padding?: string
  secondary?: boolean
}

import styled from 'styled-components'
import Divider from 'antd/lib/divider'
import { BLACK, BLUE, RED, WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

export const Container = styled.div`
  width: ${({ width }: ContainerProps) => (width ? width : 'unset')};
`

export const Title = styled.div`
  display: ${({ display }: TitleProps) => (display ? display : 'block')};
  align-items: ${({ alignItems }: TitleProps) => (alignItems ? alignItems : 'unset')};
  width: ${({ titleWidth }: TitleProps) =>
    titleWidth ? titleWidth : '411.45px'};
  color: ${({ titleColor }: TitleProps) =>
    titleColor ? titleColor : '#5f6062'};
  font-size: ${({ fontSize }: TitleProps) => (fontSize ? fontSize : '16px')};
  font-weight: 600;
  line-height: 22px;
  span {
    color: ${RED};
  }
  a {
    color: ${BLUE};
    text-decoration: underline;
  }
  svg {
    margin-right: 12px;
    color: #7390aab5;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }
`

export const ProductInfoTitle = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6px 50px;
  width: 100%;
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  background: #f1f1f1;
  &:hover {
    cursor: pointer;
  }
`

export const UpDownArrow = styled(Icon)`
  display: flex;
  background: ${({ secondary }: DivProps) => secondary ? '#84b2c2' : WHITE};
  border-radius: 25px;
  width: 26px;
  height: 26px;
  padding: 6px;
  margin-top: -3px;
  margin-bottom: -3px;
  box-shadow: 1px 2px 3px -1px #9a9a9a;
  align-items: center;
  justify-content: center;
  color: ${({ secondary }: DivProps) => secondary ? WHITE : BLACK};
  border: 1px solid;
  border-color: ${({ secondary }: DivProps) => secondary ? WHITE : '#878787'};
  transition: all .25s;
  z-index: 2;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const StyledDivider = styled(Divider)`
  margin: 10px 0;
  border-bottom: 1px solid #bebebe;
`
export const DescriptionContent = styled.div`
  color: #5f6062;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 0px;
  transition: visibility 0s, opacity 0.5s linear;
  a {
    color: ${BLUE};
    text-decoration: underline;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductInfoCustom/styledComponents.tsx